import React from 'react';
import {Col, Row} from "antd";
import EntityCard from "./EntityCard";
import {Types} from "../../settings/Interfaces";


type EntitySummaryProps={
  data?: Types.Entity[]
}

function EntitySummary(props: EntitySummaryProps) {
  return (

      <Row gutter={20}>
        <Col span={24} style={{height: 32}}></Col>
        {
          props.data?.map((e) => {
            return (
                <Col span={8} key={e.id}>
                  <EntityCard data={e}/>
                </Col>
            )
          })}
      </Row>

  );
}

export default EntitySummary;
